import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"left","width":"1100px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_grid = _resolveComponent("vxe-grid")!
  const _component_vxe_modal = _resolveComponent("vxe-modal")!

  return (_openBlock(), _createBlock(_component_vxe_modal, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    "show-zoom": "",
    resize: "",
    width: "1200px",
    title: _ctx.title,
    "esc-closable": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_vxe_grid, _mergeProps({
          border: "full",
          "show-overflow": "",
          ref: "tableRef"
        }, _ctx.gridOptions, {
          data: _ctx.tableData,
          align: "right"
        }), {
          asset: _withCtx(({ row,column }) => [
            _createElementVNode("span", {
              style: _normalizeStyle({color:(row[column.field]>=0 ? 'red':'green')})
            }, _toDisplayString(row[column.field]?.toFixed(8)), 5)
          ]),
          number4: _withCtx(({ row,column }) => [
            _createTextVNode(_toDisplayString(row[column.field]?.toFixed(4)), 1)
          ]),
          number: _withCtx(({ row,column }) => [
            _createTextVNode(_toDisplayString(row[column.field]?.toFixed(2)), 1)
          ]),
          profit: _withCtx(({ row }) => [
            _createElementVNode("span", {
              style: _normalizeStyle({color:(row['usdValue']>row['costUsdt'] ? 'red':'green')})
            }, _toDisplayString((row['usdValue']-row['costUsdt']).toFixed(2)), 5)
          ]),
          increase: _withCtx(({ row,column }) => [
            _createElementVNode("span", {
              style: _normalizeStyle({color:(row[column.field]>0 ? 'red':'green')})
            }, _toDisplayString(row[column.field]?.toFixed(2)) + "% ", 5)
          ]),
          _: 1
        }, 16, ["data"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}